module.exports = __webpack_public_path__ + "img/royal hospitals dr glory shoot-110.d4b449b9.webp";